import React from "react"
import Img from "gatsby-image/withIEPolyfill"
import { css, logTool } from "@jsUtils"
import { CONSTANTS } from "@data"

import Styles from "./articleimage.module.scss"

const log = logTool()

const { IMAGE_DISPLAY } = CONSTANTS

const ArticleImage = props => {
  log("ArticleImage: ", props)

  const { data } = props
  const { appearance, content, title } = data
  const fixed = !!(appearance === IMAGE_DISPLAY.FIXED)

  if (fixed) {
    log("fixed image size: ", content.fixed.height, content.fixed.width)
  }

  // for article images, they wanted them centered, no larger than the
  // fixed dimensions (when set for Fixed) and able to scale down.
  // So we set a maxWidth based on the fixed image dimensions data
  const size = fixed ? { maxWidth: `${content.fixed.width}px` } : {}

  return (
    <div className={css(Styles.mdcopy, Styles.img)}>
      <figure className={css(Styles.mdcopy, fixed && Styles.fixed)} data-image-type={appearance}>
        <Img className={Styles.fixedFluid} fluid={content?.fluid} alt={title} style={size} />
        {data.content?.description && <figcaption>{data.content.description}</figcaption>}
      </figure>
    </div>
  )
}

export default ArticleImage
